exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".transfer-size .el-transfer-panel{width:400px;height:500px}.transfer-size .el-checkbox-group{height:380px}.transfer-footer{margin-left:20px;padding:6px 5px}.pagina{margin-top:1.5px;margin-right:140px;width:40%;float:right}.controll{margin-top:15px}.el-transfer-panel__body .el-input__inner{height:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-121829d5!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/market/AdPush.vue
// module id = 569
// module chunks = 2